type BackendStatus = {
  errorCode?: number;
  status?: string;
  message?: string;
  infoList?: string[];
};

type BackendResponse = {
  timestamp?: string;
  errorCode?: number;
  status?: string;
  reason?: string;
  businessErrorCode?: string;
  errorDetail?: string;
  message?: string;
  localizedMessage?: string;
};

type BackendEnvelope = {
  status?: BackendStatus;
  response?: BackendResponse;
};

const asEnvelope = (raw: any): BackendEnvelope => {
  if (!raw || typeof raw !== "object") return {};

  if (raw.status || raw.response) return raw as BackendEnvelope;
  if (raw.data && (raw.data.status || raw.data.response)) return raw.data as BackendEnvelope;

  return {};
};

const firstTruthy = (...values: Array<any>) => values.find((value) => Boolean(value));

export const parseBackendNotificationDetails = (raw: any) => {
  const envelope = asEnvelope(raw);
  const status = envelope.status || {};
  const response = envelope.response || {};

  const errorCode = firstTruthy(response.errorCode, status.errorCode);
  const reason = firstTruthy(response.reason, response.status, status.status);
  const message = firstTruthy(
    response.localizedMessage,
    response.message,
    response.errorDetail,
    status.message
  );

  const infoParts: string[] = [];

  if (response.businessErrorCode) {
    infoParts.push(`Business Code: ${response.businessErrorCode}`);
  }
  if (errorCode) {
    infoParts.push(`Error Code: ${errorCode}`);
  }
  if (response.timestamp) {
    infoParts.push(`Timestamp: ${response.timestamp}`);
  }
  if (Array.isArray(status.infoList) && status.infoList.length > 0) {
    infoParts.push(`Info: ${status.infoList.join(", ")}`);
  }

  return {
    errorCode,
    reason,
    message,
    info: infoParts.join(" | "),
  };
};

/** Payload shape expected by `Notification` / `MDSnackbar` via `showGlobalNotification`. */
export type GlobalNotificationDetail = {
  color: string;
  icon: string;
  title: string;
  reason: string;
  content: string;
  info?: string;
};

export function dispatchGlobalNotification(detail: GlobalNotificationDetail): void {
  window.dispatchEvent(new CustomEvent("showGlobalNotification", { detail }));
}

export function notifyValidationWarning(title: string, content: string): void {
  dispatchGlobalNotification({
    color: "warning",
    icon: "warning",
    title,
    reason: "Validation",
    content,
    info: "",
  });
}

export function notifySuccessShort(content: string, title = "Done"): void {
  dispatchGlobalNotification({
    color: "success",
    icon: "check_circle",
    title,
    reason: "App",
    content,
    info: "",
  });
}

